<template>
  <div class="block">
    <ul class="tab" ref="tabs">
      <li class="tab-item" v-for="{ id, name, icon, src } in tabs" :class="activeTabId === id ? 'active' : ''" :key="id"
        @mousedown="setActiveTab(id)" @contextmenu.prevent="showDialog($event, id, src)">
        <img :src="icon || require('@/assets/images/app_logo_base.png')" class="icon" alt="" />
        <div class="text">
          {{ name }}
        </div>
        <div class="close-icon" v-if="id !== -1" @click.stop="close(id, 'cloneOne')">
          <img src="../../assets/images/close-icon.png" />
        </div>
        <div :class="activeTabId === id || prevId === id ? '' : 'driver'"></div>
      </li>

      <el-card v-if="show" :style="cardPoi" :body-style="{ padding: '6px 16px' }" class="box-card">
        <li @click="reflash()">重新加载</li>
        <li @click="copyLink()">复制链接</li>
        <li @click="openLink()">在浏览器中打开</li>
        <el-divider style="margin: 10px 0px"></el-divider>
        <li :class="activeTabId === -1 ? 'disable' : ''" @click="close(undefined, 'cloneOne')">
          关闭
        </li>
        <li @click="close(undefined, 'cloneAll')">关闭其他标签页</li>
        <li :class="canCloseRight ? 'disable' : ''" @click="close(undefined, 'cloneRight')">
          关闭右侧标签页
        </li>
      </el-card>
    </ul>
  </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
  data() {
    return {
      active: 0,
      cardPoi: {
        left: 0,
      },
      mouseCurId: -1,
      show: false,
      src: "",
      dragItemId: "",
    };
  },
  mounted() {
    this.initEvent();
    this.initSortable();
  },
  computed: {
    tabs: ({ $store }) => $store.state.tabs,

    activeTabId: ({ $store }) => $store.state.activeTabId,

    canCloseRight: ({ $store, mouseCurId }) => {
      const { tabs } = $store.state;
      const index = tabs.findIndex(({ id }) => id === mouseCurId);
      return index === tabs.length - 1;
    },

    prevId({ activeTabId, tabs, dragItemId, isDrap }) {
      let index = isDrap
        ? dragItemId
        : tabs.findIndex(({ id }) => id === activeTabId);
      console.log(index, isDrap);
      let preId = "";
      if (index > 0) {
        preId = tabs[--index].id;
      }
      console.log(preId);
      return preId;
    },
  },
  methods: {
    dropHandler(newIndex, oldIndex) {
      if (newIndex === oldIndex) {
      }
      console.log(newIndex, oldIndex);
      const tabs = [...this.$store.state.tabs];

      const temp = tabs[newIndex];
      tabs[newIndex] = tabs[oldIndex];
      tabs[oldIndex] = temp;
      this.$store.commit("setTab", tabs);
    },
    initEvent() {
      const fn = () => {
        this.show = false;
      };
      document.addEventListener("click", fn);
      this.$once("hook:beforeDestroy", () => {
        document.removeEventListener("click", fn);
      });
    },
    initSortable() {
      const ref = this.$refs.tabs;
      new Sortable(ref, {
        onStart: () => {
          this.isDrap = true;
        },
        onEnd: ({ newIndex, oldIndex }) => {
          this.isDrap = false;
          this.dropHandler(newIndex, oldIndex);
        },
        onChange: ({ newIndex, oldIndex }) => {
          this.dragItemId = newIndex;
          console.log("onSort", newIndex, oldIndex);
        },
      });
    },
    copyLink() {
      console.log(this.src);
      this.$copyText(this.src).then(
        () => this.$message.success("复制成功"),
        () => this.$message.error("复制失败")
      );
    },
    openLink() {
      //浏览器环境
      let tempwindow = window.open("_blank");
      tempwindow.location = this.src;
    },
    reflash() {
      const parent = this.$parent;
      const id = this.mouseCurId;
      console.log(id);
      // 首页刷新
      if (id === -1) {
        parent.key = (Math.random() * 100000).toFixed();
        return;
      }
      //iframe 刷新
      const [iframe] = parent.$refs[`iframe-${id}`];
      if (iframe) {
        //reload 显示跨域，用replace
        iframe.contentWindow.location.replace(this.src);
      }
    },
    showDialog(e, id, src) {
      const { clientX, clientY } = e;
      const cardPoi = {
        left: clientX + "px",
        top: clientY + "px",
      };
      console.log(src);
      Object.assign(this, {
        show: true,
        mouseCurId: id,
        src,
        cardPoi,
      });
    },
    setActiveTab(id) {
      this.$store.commit("setActiveTab", id);
    },

    close(id = this.mouseCurId, removeType) {
      this.$store.dispatch("removeTab", {
        removeType,
        data: {
          id,
        },
      });
    },
  },
};
</script>   

<style lang="less" scoped>
.block {
  height: 40px;
  width: 100%;
}

.tab {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  height: 44px;
  // background-color: rgba(223, 224, 226, 1);
  background-color: rgba(223, 224, 226, 1);
  flex-wrap: nowrap;
  border-bottom: 4px solid #fff;
  align-items: flex-end;
  padding: 0 20px;
  box-sizing: border-box;
  z-index: 1111;
  width: 100%;
  font-size: 12px;
  color: #3c3f44;
}

.tab-item {
  display: flex;
  align-items: center;
  width: 256px;
  height: 34px;
  min-width: 92px;
  position: relative;
  background-color: transparent;
  border-radius: 12px 12px 0 0;
  box-sizing: border-box;
  padding: 0 12px;
  white-space: nowrap;
  // overflow: hidden;
  cursor: pointer;
  padding-right: 30px;

  &::after,
  &::before {
    position: absolute;
    bottom: 0;
    content: "";
    width: 20px;
    height: 20px;
    border-radius: 100%;
    box-shadow: 0 0 0 40px transparent;
  }

  &::after {
    left: -20px;
    clip-path: inset(50% -10px 0 50%);
  }

  &::before {
    right: -20px;
    clip-path: inset(50% 50% 0 -10px);
  }

  &:hover {
    background-color: rgba(223, 224, 226, 0.5);
    /* color: #000; */
  }

  &:hover::before,
  &:hover::after {
    box-shadow: 0 0 0 30px rgba(223, 224, 226, 0.5);
  }

  &.active {
    background-color: #fff;
    z-index: 1;
    /* color: #000; */
  }

  &.active::before,
  &.active::after {
    box-shadow: 0 0 0 30px #fff;
  }

  .text {
    // display: flex;
    max-width: 124px;
    // max-width: 120px;
    // min-width: 30px;
    overflow: hidden;
  }

  .icon {
    width: 17px;
    height: 17px;
    margin-right: 10px;
  }

  .close-icon {
    position: absolute;
    top: 50%;
    right: 2px;
    transform: translateY(-50%);
    box-sizing: content-box;
    padding: 6px 8px;

    // width: 8px;
    // height: 8px;
    img {
      width: 8px;
      height: 8px;
    }
  }
}

.driver {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: rgb(138, 138, 138);
  width: 1px;
  height: 60%;
}

.el-divider--horizontal {
  margin: 6px 0;
}

.box-card {
  position: fixed;
  transition: none;
  width: 154px;
  z-index: 222;
  background: #eaeaeb;
  border: 0.5px solid rgba(173, 173, 173, 1);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.18);
  border-radius: 6px;
  font-size: 13px;
  color: #222222;
  line-height: 13px;
  font-weight: 400;
  font-family: PingFangSC-Regular;

  // padding: 12px 16px;
  & li {
    height: 24px;
    line-height: 26px;
    user-select: none;

    &:hover {
      background: #e0e0e0;
    }
  }

  .disable {
    pointer-events: none;
    cursor: not-allowed;
    color: #ababab;
  }
}
</style>